export class FormApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getForm(params) {
    return this.#http.get('/Form', { params });
  }

  async createForm(body) {
    return this.#http.post('/Form', body);
  }

  async getFormByLoanId({ loanId, ...params }) {
    return this.#http.get(`/Form/loan-id/${loanId}`, { params });
  }

  async createFormPdf({ signal, formData, ...params }) {
    return this.#http.post('/Form/pdf', formData, {
      signal,
      headers: { 'Content-Type': 'multipart/form-data' },
      params,
    });
  }

  async editForm({ formId, ...body }) {
    return this.#http.put(`/Form/${formId}`, body);
  }

  async deleteFrom({ formId }) {
    return this.#http.delete(`/Form/${formId}`);
  }

  async getFormTemplate({ formId, ...params }) {
    return this.#http.get(`/Form/${formId}/template`, { params });
  }

  async editFormTemplate({ formId, formData, ...params }) {
    return this.#http.put(`/Form/${formId}/template`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params,
    });
  }

  async getFormSchema(params) {
    return this.#http.get('/Form/schema', { params });
  }

  async getFormSchemaById({ formId, ...params }) {
    return this.#http.get(`/Form/schema/${formId}`, { params });
  }

  async createFormTemplatePdf({ formId, ...body }) {
    return this.#http.post(`/Form/${formId}/template/pdf`, body);
  }

  async getFormTemplatePdf({ formId, ...params }) {
    return this.#http.get(`/Form/${formId}/template/pdf`, { params });
  }

  async editFormTemplatePdf({ formId, ...body }) {
    return this.#http.put(`/Form/${formId}/template/pdf`, body);
  }

  async getFormPreviewPdf({ formId, ...params }) {
    return this.#http.get(`/Form/${formId}/preview/pdf`, { params, responseType: 'blob' });
  }

  async getFormPreviewSigning({ formId, ...params }) {
    return this.#http.get(`/Form/${formId}/preview/signing`, { params });
  }

  async previewPrismFormPdf({ formId, document, margins, pageNumbering, watermark, ...params }) {
    return this.#http.post(
      `/Form/${formId}/preview/pdf`,
      { document, margins, pageNumbering, watermark },
      { params, responseType: 'blob' },
    );
  }

  async getFormHistory({ formId, ...params }) {
    return this.#http.get(`/Form/${formId}/history`, { params });
  }

  async getFormHistorySnapshotByEntryId({ formId, entryId, ...params }) {
    return this.#http.get(`/Form/${formId}/history/${entryId}/snapshot`, { params });
  }

  async getFormHistorySnapshotPdfByEntryId({ formId, entryId, ...params }) {
    return this.#http.get(`/Form/${formId}/history/${entryId}/snapshot/pdf`, { params });
  }

  async getGeneratedFormByLoanNumber({ formId, loanNumber }) {
    return this.#http.get(`/Form/${formId}/loan-number/${loanNumber}/generate`, {
      responseType: 'blob',
    });
  }

  async getGeneratedFormByApplicationId({ formId, applicationId }) {
    return this.#http.get(`/applications/${applicationId}/forms/${formId}/generate`, {
      responseType: 'blob',
    });
  }
}
